
define('ldsh!templates/modal', ['lodash'], function(_) {return function(obj) {
obj || (obj = {});
var __t, __p = '', __e = _.escape, __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
with (obj) {
__p += '<div class="modal">\n  <label class="modal__bg"></label>\n  <div class="modal__inner ' +
__e( modalExtraClass ) +
'" style="' +
__e( modalExtraStyle ) +
'">\n    <div>\n      <label class="modal__close"></label>\n      <h2 class="i18n" data-i18n="' +
__e( title ) +
'"></h2>\n      <p class="i18n" data-i18n="' +
__e( description ) +
'"></p>\n      ';
 if (body) { ;
__p += '\n      <div class="modal__body">\n        ' +
__e( body ) +
'\n      </div>\n      ';
 } ;
__p += '\n    </div>\n    <div class="modal__footer">\n      ';
 if (cancelText) { ;
__p += '\n      <button\n        id="cancelModal"\n        type="button"\n        class="btn btn-link i18n mr-20"\n        data-i18n="' +
__e( cancelText ) +
'"\n      ></button>\n      ';
 } ;
__p += '\n      <button\n        id="submitModal"\n        type="button"\n        class="btn boton-principal js-save">\n        <i class="fa-li fa fa-spinner fa-spin" style="display: none;"></i>\n        <span class="i18n" data-i18n="' +
__e( submitText ) +
'"></span>\n      </button>\n    </div>\n  </div>\n</div>\n';

}
return __p
};});

